import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { AssetInterface } from "../../../../models/AssetModel/Asset";
import assetService from "../../../../services/assetService/assetService";

const useAssetByTitleCompLocCustomer = (
  page: number,
  pageSize: number,
  searchTerm: string,
  companyId: string | undefined,
  locationId: string | undefined,
  customerId: string | undefined
) =>
  useQuery<AssetInterface[], Error>({
    queryKey: [
      `${CACHE_KEY_ASSETS}ByTitle`,
      page,
      pageSize,
      searchTerm.length >= 3 || searchTerm.length === 0,
      companyId,
      locationId,
      customerId,
    ],
    queryFn: () =>
      assetService.GetByTitleCompLocCustomer(
        page,
        pageSize,
        searchTerm,
        companyId,
        locationId,
        customerId
      ),
  });

export default useAssetByTitleCompLocCustomer;
